import wx from 'weixin-js-sdk'
import Axios from 'axios'
const wxApi = {
  wxRegister (callback) {
    Axios.post('/api/share', { url: window.location.href }, { timeout: 5000, withCredentials: true }).then((res) => {
      let data = JSON.parse(res.data) 
      // console.log(data)
      // console.log(data.appId,data.timestamp,data.nonceStr,data.signature,data.jsApiList )
      wx.config({
        debug: false, // 开启调试模式
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录1
        jsApiList: data.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
    }).catch((err) => {
      console.log("错误")
      console.log(err)
    })
    wx.ready((res) => {
      // 如果需要定制ready回调方法
      if (callback) {
       console.log(callback)
       callback()
      }
    })
  },

  ShareTimeline (option) {
    wx.onMenuShareTimeline({
      title: option.title, // 分享标题
      desc:option.desc,   //分享的描述
      link: option.link, // 分享链接
      imgUrl: option.imgUrl, // 分享图标
      success () {
        // 用户成功分享后执行的回调函数
        option.success()
      },
      cancel () {
        // 用户取消分享后执行的回调函数
        option.error()
      }
    })
  },

  ShareAppMessage (option) {
    wx.onMenuShareAppMessage({
      title: option.title, // 分享标题
      desc: option.desc, // 分享描述
      link: option.link, // 分享链接
      imgUrl: option.imgUrl, // 分享图标
      success () {
        // 用户成功分享后执行的回调函数
        option.success()
      },
      cancel () {
        // 用户取消分享后执行的回调函数
        option.error()
      }
    })
  }
}
export default wxApi


// WEBPACK FOOTER //
// ./src/public/wxapi.js